/* ************************************************************************** */
/*                                  Component                                 */
/* ************************************************************************** */

// Lib dependencies
import { useReactiveVar } from '@apollo/client';
import { useTranslation } from 'react-i18next';

// UI lib components
import { Container } from '@mantine/core';

// UI local components
import ConfirmBar from '@ui-kit/molecules/ConfirmBar';

// Store
import dialogStoreVar from '@features/Dialog/store/dialogStore';

// Local Types
import { DialogSupportConfirmationProps } from './type';

/* ************************************************************************** */
/*                                  Component                                 */
/* ************************************************************************** */

function DialogSupportConfirmation({
  onConfirm,
  ...props
}: DialogSupportConfirmationProps) {
  /* ********************************** HOOKS ********************************* */

  // Store
  const dialogStore = useReactiveVar(dialogStoreVar);

  // Localization
  const { t } = useTranslation(['Common']);

  /* ******************************** RENDERING ******************************* */

  return (
    <Container w="30vw" fluid>
      <ConfirmBar
        labelProps={{
          confirm: t(
            'Support:QuestionMenu.thread.dialogSupportConfirmation.ctaConfirm',
          ),
          cancel: t('Common:cta.cancel'),
        }}
        onConfirm={() => {
          dialogStore?.closeDialog?.('dialog-support-confirmation');
          onConfirm();
        }}
        onCancel={() => {
          dialogStore?.closeDialog?.('dialog-support-confirmation');
        }}
      />
    </Container>
  );
}

export default DialogSupportConfirmation;
